import { getLogin, getInfo } from '@/api/user'
import { getToken, setToken, removeToken } from '@/utils/auth'
import { resetRouter } from '@/router'
import request from '@/api/index.js'
const getDefaultState = () => {
  return {
    token: getToken(),
    name: '',
    avatar: '',
    hasPermissionMenu: [],
    allMenu: [],
  }
}

const state = getDefaultState()

const mutations = {
  RESET_STATE: (state) => {
    Object.assign(state, getDefaultState())
  },
  SET_TOKEN: (state, token) => {
    console.log(token)
    state.token = token
  },
  SET_NAME: (state, name) => {
    state.name = name
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar
  },
  SET_ALL_MENU: (state, allMenu) => {
    state.allMenu = allMenu
  },
  SET_HAS_PERMISSION_MENU: (state, hasPermissionMenu) => {
    state.hasPermissionMenu = hasPermissionMenu
  }
}

const actions = {
  // user login
  // getLogin({ commit }, userInfo) {
  //   const { username, password } = userInfo
  //   return new Promise((resolve, reject) => {
  //     const formData = new FormData()
  //     formData.append('username', username.trim())
  //     formData.append('password', password.trim())
  //     formData.append('loginType', 'login_manage')
  //     request.getLogin(formData).then(response => {
  //       const { data } = response
  //       console.log(data)
  //         commit('SET_TOKEN', data.accessToken)
  //         setToken(data.accessToken)
  //         resolve()
  //     }).catch(error => {
  //       reject(error)
  //     })
  //   })
  // },
  //
  // // get user info
  getInfo({ commit, state }) {
    return new Promise((resolve, reject) => {
      request.getInfo().then(response => {
          const { data } = response
          sessionStorage.setItem('userId', response.data.lxUserId)
          if (!data) {
            return reject('登录信息错误，请重新登录')
          }
          const { username, avatar } = data
          commit('SET_NAME', username)
          commit('SET_AVATAR', avatar)
          resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  getMenu({ commit, state }) {
    return new Promise((resolve, reject) => {
      request.getUserMenu().then(res => {
        const menuList = res.data.filter(item => item.hasPermission)
        const hasPermissionPaths = menuList.map(item => item.path)
        const allPaths = res.data.map(item => item.path)
        commit('SET_HAS_PERMISSION_MENU', menuList)
        commit('SET_ALL_MENU', res.data)
        resolve({
          allPaths,
          hasPermissionPaths,
          menuList
        })
      })
    })
  },

  // // user logout
  // logout({ commit, state }) {
  //   return new Promise((resolve, reject) => {
  //     logout(state.token).then(() => {
  //       removeToken() // must remove  token  first
  //       resetRouter()
  //       commit('RESET_STATE')
  //       resolve()
  //     }).catch(error => {
  //       reject(error)
  //     })
  //   })
  // },

  // remove token
  resetToken({ commit }) {
    return new Promise(resolve => {
      removeToken() // must remove  token  first
      commit('RESET_STATE')
      resolve()
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}

